import React from "react"
import CustomTable from "../../components/CustomTable";
import { addCastesName, casteUpdateApprovedAndUnapproved, editCastesName, getAllCastes } from "../../services/ApiServices";
import { ApprovedAndUnApprovedBtn } from "../../components/ApprovedAndUnApprovedBtn";
import { EditButton } from "../../components/masterDataForm/EditButton";
import EditMasterForm from "../../components/masterDataForm/EditMasterForm";
import { AddButton } from "../../components/masterDataForm/AddButton";
import AddMasterForm from "../../components/masterDataForm/AddMasterForm";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
const Castes = () => {

    const dispatch = useDispatch();
    const castesInfo = useSelector(state => state?.getAllCastes?.castes);

    const [showCastes, setCastesShow] = React.useState(false);
    const [showAddCastes, setAddCastesShow] = React.useState(false);
    const [castesValName, setCastesValName] = React.useState();


    React.useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await getAllCastes();
                dispatch({ type: "GET_ALL_CASTES", payload: res.data.data });
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        fetchUsers();
    }, [dispatch]);

    const addCastesHandle = async (castesName) => {
        try {
            const addCastesNames = await addCastesName(castesName);
            if(addCastesNames.status === 200) {
                dispatch({ type: 'ADD_CASTES_NAME', payload: addCastesNames.data?.data})
                toast.success(addCastesNames.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };
    const editCastesHandle = async (castes) => {
        try {
            const castesPayload = {
                casteId: castes?.statusId,
                name: castes?.name
            }
            const editCastesNames = await editCastesName(castesPayload);
            if(editCastesNames.status === 200) {
                dispatch({ type: 'UPDATE_CASTES_NAME', payload: editCastesNames.data?.data})
                toast.success(editCastesNames.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };

    const casteApprovedAndUnAprooved = async (casteId) => {
        try {
            const approvedAndUnapprovedStatus = await casteUpdateApprovedAndUnapproved(casteId);
            if(approvedAndUnapprovedStatus.status === 200) {
                dispatch({ type: 'UPDATE_CASTES_STATUS', payload: approvedAndUnapprovedStatus.data?.data})
                toast.success(approvedAndUnapprovedStatus.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };

    const colDefs = [
            { field: "name", flex: 2, headerName: 'Name' },
            { field: "isApproved", flex: 2, headerName: 'Status', cellRenderer: (val) => {
            return ( <ApprovedAndUnApprovedBtn status={val?.data?.isApproved} statusId={val.data._id} handleApprovedAndUnAprooved={casteApprovedAndUnAprooved}/> )
            }
        },
            { field: '_id', flex: 2, headerName: 'Action', cellRenderer: (val) => ( <EditButton name={val.data.name} statusId={val.data._id} hadnleEditName={setCastesValName} handleEditBtn={setCastesShow}/>) }
        ];

    return(
        <React.Fragment>
            <div className="aside-heading">
                <h3>Castes</h3>
            </div>
            <AddButton formName="Caste" handleAddBtn={setAddCastesShow} />
            <CustomTable colDefs={colDefs} rowData={castesInfo} />
            <AddMasterForm formName="Castes" addMasterData={addCastesHandle} showAddForm={showAddCastes} setShowAddForm={setAddCastesShow} />
            <EditMasterForm formName="Castes" editMasterDataName={castesValName} editMasterData={editCastesHandle} showEditForm={showCastes} setShowEditForm={setCastesShow}/>
        </React.Fragment>
    )
};
export default Castes;